<template lang="pug">
#relatorios
    div(v-if='historico')
        BaseHeader(
            :titulo='$t("mensagens.operacao.monitoramento.detalhesMonitoramento")',
            :voltarPara='true',
            :exibeBotao='false'
        )
            template(slot='direita')
                .relatorios_titulo
                    span {{ $t('mensagens.operacao.dashboard.data') }} {{ historico.dataMonitoramento }}

        section.relatorios__cards
            CardDadosDashboardMonitoramento(
                :titulo='$t("mensagens.operacao.monitoramento.operacoesMonitoradas")',
                :valor='historico.quantidadeOperacao'
            )
            CardDadosDashboardMonitoramento(
                :titulo='$t("mensagens.operacao.monitoramento.territoriosMonitorados")',
                :valor='historico.quantidadeTerritorio'
            )
            CardDadosDashboardMonitoramento(
                :titulo='$t("mensagens.operacao.monitoramento.pessoasMonitoradas")',
                :valor='historico.quantidadePessoa'
            )

        section.relatorios__tabela(v-loading='carregandoTabela')
            el-table(
                :data='detalhes',
                stripe,
                height='calc(100% - 48px)',
                @sort-change='ordenar'
            )
                el-table-column(:label='$t("mensagens.operacao.titulo")',  sortable='custom')
                    template(slot-scope='scope')
                        span {{ scope.row.identificadorOperacao }}

                el-table-column(
                    :label='$t("mensagens.operacao.monitoramento.territorioPessoa")',  sortable='custom'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.tipo === 'TERRITORIO' ? `${scope.row.territorio.nome} (${scope.row.territorio.cars.length ? scope.row.territorio.cars[0].codigo : ''}) ` : `${scope.row.pessoa.nome}` }}

                el-table-column(
                    :label='$t("mensagens.operacao.tabela.ultimaAtualizacao")',
                    align='center'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.tipo === 'PESSOA' ? scope.row.pessoa.dataUltimaAtualizacao : scope.row.territorio.dataUltimaAtualizacao }}

            .tabela-rodape
                .tabela-rodape--esquerda
                    p {{ paginacao.total }} {{ $t('mensagens.operacao.monitoramento.registros') }}
                .tabela-rodape--pagination
                    el-pagination(
                        small,
                        layout='prev, pager, next',
                        :page-size='paginacao.itensPorPagina',
                        :current-page.sync='paginacao.pagina',
                        :total='paginacao.total',
                        @current-change='buscarRelatorios(paginacao.pagina - 1)'
                    )
    .empty(v-else)
        el-empty(
            :description='$t("mensagens.operacao.monitoramento.nenhumResultado")'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import CardDadosDashboardMonitoramento from '@/components/operacao/dashboard-monitoramento/CardDadosDashboardMonitoramento';
import OperacaoDashboardMonitoramentoService from '@/services/OperacaoDashboardMonitoramentoService';

export default {
    name: 'RelatorioMonitoramentoOperacaoTerritorios',

    components: {
        BaseHeader,
        CardDadosDashboardMonitoramento
    },

    data() {
        return {
            historico: this.$route.params.historico,
            detalhes: [],
            carregandoTabela: false,
            paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
            }
        };
    },

    mounted() {
        if (!this.historico) {
            this.$router.go(-1);
            return;
        }
        this.buscarRelatorios();
    },

    methods: {
        ordenar(props) {
            this.paginacao.direcao = props.order;
            this.paginacao.ordernarPor = props.column.label;

            if (props.order === null) this.paginacao.ordernarPor = null;
            this.buscarRelatorios(0);
        },

        async buscarRelatorios(pagina) {
            try {
                this.carregandoTabela = true;
                this.paginacao.pagina = pagina;
                const direcao =
                    this.paginacao.direcao &&
                    this.paginacao.direcao.includes('ascending')
                        ? 'ASC'
                        : 'DESC';

                const { data } =
                    await OperacaoDashboardMonitoramentoService.buscarRelatorios(
                        {
                            historicoId: this.historico.id,
                            paginacao: { ...this.paginacao, direcao: direcao }
                        }
                    );
                this.detalhes = data.itens;

                this.paginacao.pagina = data.paginacao.pagina + 1;
                this.paginacao.total = data.paginacao.total;
                this.paginacao.itensPorPagina = data.paginacao.itensPorPagina;
                this.paginacao.totalPaginas = data.paginacao.totalPaginas;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.operacao.monitoramento.historico.relatorio.detalhe.erro.erroBuscaDetalhesHistoricoMonitoramento'
                    )
                );
                throw error;
            } finally {
                this.carregandoTabela = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#relatorios {
    .relatorios_titulo {
        width: 20vw;
        height: 7vh;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: large;
    }

    .relatorios__cards {
        width: 98%;
        margin: 2% 1%;
        padding: 1% 0;
        display: flex;
        justify-content: space-around;
        background-color: white;
    }

    .relatorios__tabela {
        padding: 0 1%;
        height: calc(100vh - 250px);
        overflow-y: auto;
    }

    .tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 44% 10px 5px;
        margin-top: 8px;
        border-radius: 5px;

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }
    .empty {
        background-color: var(--white);
        height: calc(100vh - 68px);
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
